import { DeckException } from "@/utils/events";
import type { DeckCustomErrorCode } from "@/types";

export class DeckError extends Error {
  appInstance: HTMLElement | undefined;
  error: Error;

  constructor(message: string, appInstance?: HTMLElement, error?: Error) {
    super(message);
    this.name = "Runtime Error";
    this.appInstance = appInstance;
    this.error = error ?? new Error(message);
  }
}

export class CriticalError extends DeckError {
  constructor(
    customErrorMessage: string,
    appInstance?: HTMLElement,
    errorCode?: DeckCustomErrorCode,
    error?: Error
  ) {
    super(customErrorMessage, appInstance, error);
    this.name = "Critical Error";

    this.emitEvent(errorCode);
  }

  /**
   * Emits error event so the parent app knows a critical error occurred
   */
  emitEvent(errorCode?: DeckCustomErrorCode) {
    const exception = new DeckException("exception", {
      error: this.error,
      detail: {
        reason: errorCode ?? "UNKNOWN_EXCEPTION",
        message: this.message
      }
    });

    this.appInstance?.dispatchEvent(exception);
  }
}

export class NonCriticalError extends DeckError {
  constructor(customErrorMessage: string, error?: Error) {
    super(customErrorMessage, undefined, error);
    this.name = "Non-Critical Error";
  }
}
